/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import apiEndpoints from '../lib/apiEndpoints';
import apiCall from './apiCall';
import { getBase64Data, getMerchantIdFromStore, isValidDate } from 'lib/helper';

export const getTodayTransactionsDataApi = (payload) => {
  const { merchantId } = payload;
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.GET_TODAY_TRANSACTIONS_DATA(merchantId),
  });
};

export const getEdgeTodayTransactionsDataApi = (payload?: { cancelKey?: string }) => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.GET_EDGE_TODAY_TRANSACTIONS_DATA,
    cancelKey: payload?.cancelKey,
  });
};

export const getOverviewDataApi = (payload) => {
  const { base64data, merchantId } = payload;
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.GET_OVERVIEW_DATA(merchantId),
    query: {
      download: 'false',
      payload: base64data,
    },
  });
};

export const getEdgeOverviewDataApi = (payload) => {
  const { base64data, cancelKey } = payload;
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.GET_EDGE_OVERVIEW_DATA,
    query: {
      download: 'false',
      payload: base64data,
    },
    cancelKey,
  });
};

export const getCheckoutInsightsOfferEffectivenessAPI = (payload) => {
  const { base64data, cancelKey } = payload;
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS,
    query: {
      payload: base64data,
    },
    cancelKey,
  });
};

export const getCheckoutInsightsPaymentPerformanceAPI = (payload) => {
  const { base64data, cancelKey } = payload;
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE,
    query: {
      payload: base64data,
    },
    cancelKey,
  });
};
export const getCheckoutInsightsPaymentModeBreakdownAPI = (payload) => {
  const { base64data, cancelKey } = payload;
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN,
    query: {
      payload: base64data,
    },
    cancelKey,
  });
};

export const getHasMerchantTransactedApi = () => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.GET_HAS_MERCHANT_TRANSACTED,
  });
};

export const getOverviewSettlementDataApi = async (payload) => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.GET_OVERVIEW_SETTLEMENT_DATA(
      getMerchantIdFromStore()
    ),
    query: {
      download: 'false',
      payload: getBase64Data(payload),
    },
  });
};

export const getEdgeOverviewSettlementDataApi = async (payload) => {
  const { cancelKey, ...requestPayload } = payload || {};
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.GET_EDGE_OVERVIEW_SETTLEMENT_DATA,
    query: {
      download: 'false',
      payload: getBase64Data(requestPayload),
    },
    cancelKey,
  });
};

export const getCheckoutInsightsConversionFunnelAPI = (payload: {
  from: string;
  to: string;
  cancelKey?: string;
}) => {
  if (!isValidDate(payload.from) || !isValidDate(payload.to)) {
    return Promise.reject(new Error('Invalid date format for from/to'));
  }

  const sanitizedFrom = new Date(payload.from).toISOString();
  const sanitizedTo = new Date(payload.to).toISOString();
  const { cancelKey } = payload;

  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.CHECKOUT_INSIGHTS_CONVERSION_FUNNEL,
    query: {
      from: sanitizedFrom,
      to: sanitizedTo,
    },
    cancelKey,
  });
};

export const getBetaToggleApi = (emailId: string, cancelKey?: string) => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.BETA_TOGGLE(emailId),
    cancelKey,
  });
};
